import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Redirect, Switch, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors'; // @ts-expect-error Could not find a declaration file for module

import { MyLearningSideNav } from '../containers/MyLearningPage/MyLearningSideNav';
import MyLearning from './MyLearning';
import UIDashboardPage from 'UIComponents/page/UIDashboardPage';
import { FILTER_CONSTS, FILTER_TYPES } from '../constants/TopFilterConstants'; // @ts-expect-error Could not find a declaration file for module

import ResultsStatusBar from '../components/ResultsStatusBar';
import { useCallback, useState } from 'react'; // @ts-expect-error Could not find a declaration file for module

import useMediaQuery from '../hooks/useMediaQuery';
import { device } from '../constants/StyledComponentConstants';
import { Route } from '../features/routing';
const SidebarSpacing = styled.div.withConfig({
  displayName: "MyLearningRouter__SidebarSpacing",
  componentId: "sc-159qb6-0"
})(["padding-top:10px;"]);
const MyLearningPageWrapper = styled.div.withConfig({
  displayName: "MyLearningRouter__MyLearningPageWrapper",
  componentId: "sc-159qb6-1"
})(["[class^='UIAbstractPageTemplate'] > section + div{border-top:0;}"]);

const MyLearningRouter = () => {
  const {
    path
  } = useRouteMatch();
  const inProgress = `${path}/in-progress`;
  const completed = `${path}/completed`;
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const [countState, setCountState] = useState({
    endCard: 0,
    cardsTotal: 0,
    startCard: 0
  });
  const updateTitleDetails = useCallback(({
    endCard,
    cardsTotal,
    startCard
  }) => {
    setCountState({
      endCard,
      cardsTotal,
      startCard
    });
  }, []);
  return /*#__PURE__*/_jsxs(MyLearningPageWrapper, {
    children: [/*#__PURE__*/_jsx(ResultsStatusBar, {
      cardsTotal: countState.cardsTotal,
      endCard: countState.endCard,
      mobileFilterTypes: [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.CONTENT_TYPE],
      showSort: true,
      showStatusSwitcher: true,
      startCard: countState.startCard
    }), /*#__PURE__*/_jsx(UIDashboardPage, {
      headerComponent: null,
      mainSectionStyle: {
        backgroundColor: OLAF
      },
      sidebarComponent: !isMobile && /*#__PURE__*/_jsx(SidebarSpacing, {
        children: /*#__PURE__*/_jsx(MyLearningSideNav, {})
      }),
      children: /*#__PURE__*/_jsxs(Switch, {
        children: [/*#__PURE__*/_jsx(Route, {
          path: [`${inProgress}/page/:page`, inProgress],
          render: prop => /*#__PURE__*/_jsx(MyLearning, Object.assign({}, prop, {
            status: FILTER_CONSTS.STATUSES.IN_PROGRESS,
            updateTitleDetails: updateTitleDetails
          }))
        }), /*#__PURE__*/_jsx(Route, {
          path: [`${completed}/page/:page`, completed],
          render: prop => /*#__PURE__*/_jsx(MyLearning, Object.assign({}, prop, {
            status: FILTER_CONSTS.STATUSES.COMPLETED,
            updateTitleDetails: updateTitleDetails
          }))
        }), /*#__PURE__*/_jsx(Redirect, {
          to: inProgress
        })]
      })
    })]
  });
};

export default MyLearningRouter;